import { FirmaElectronicaService } from './../../../services/firma-electronica/firma-electronica.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from 'app/models/messages';
import { GuiasService } from 'app/services/guias/guias.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { Persona } from '../../../models/Persona';
import { ActivatedRoute } from '@angular/router';
import Swal from "sweetalert2";
import * as moment from 'moment';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { environment } from 'environments/environment';
export const MY_FORMATS  ={
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
declare var $: any;
@Component({
  selector: 'app-nuevo-contrato-marco',
  templateUrl: './nuevo-contrato-marco.component.html',
  styleUrls: ['./nuevo-contrato-marco.component.scss'],
  providers:[MessagesTitles, MessagesStatus,Persona,{
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },
  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class NuevoContratoMarcoComponent implements OnInit {
    
  @Output() cerrarContratoMarcoNuevo: EventEmitter<boolean>;
  
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  Id_Descuento=environment.ID_DESCUENTO;
  Id_Contrato_Marco=environment.TIPO_PROCESO.CONTRATO_MARCO;
  razSocial : string;
  loading: boolean = false;
  save: boolean = false;
  contactosArray: any;
  user: any;
  formularioGenerarContrato: FormGroup;
  idEmpresa: string;
  Titulo:string;

  rProvCombo: any = [];
  rProvArray: any = [];
  rRefBancariaArray: any = [];
  rProvRefBancarias: any = [];
  rProvRefBancariasDolares: any = [];
  tipoServicio: any;

  selectedItems = [];
  selectedItemsCLI = [];

  abrirAgregarContacto : boolean;
  idContactoS: string;
  dataEnviar :any={};
  dataEnviarKeynua :any={};
  dataContract : any = [];
  tipoServicioElement = this.Id_Factoring;
  Codigo = 'CONF';
  Pagare :any;

  constructor(
      private empresasService: EmpresasService,
      private routerActive: ActivatedRoute,
      private datePipe: DatePipe,
      private guiasService : GuiasService,
      private msgTitulos : MessagesTitles,
      private msgStatus:MessagesStatus,
      private firmaElectronicaService:FirmaElectronicaService) { 

    this.cerrarContratoMarcoNuevo = new EventEmitter();
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.razSocial = sessionStorage.getItem('razSocial');
    this.Titulo = "Nuevo Contrato Marco";
    this.tipoServicio = this.empresasService.tipoServicio     

    this.routerActive.params.subscribe( params => {
      this.idEmpresa = params['id']; 
    })

   this.formularioGenerarContrato = new FormGroup({
    "idEmpresa":new FormControl(this.idEmpresa,  Validators.required),
    "Tipo_Servicio":new FormControl(this.tipoServicioElement,  Validators.required),
    "Fecha_Inicio": new FormControl('',  Validators.required),
    "Fecha_Final": new FormControl('',  Validators.required),
    "Pagare": new FormControl(true,  Validators.required),
    "IF_Representante_Legal_1": new FormControl(''),
    "PRV_Representante_Legal_1": new FormControl(''),
    "IF_Representante_Legal_2": new FormControl(''),
    "PRV_Representante_Legal_2": new FormControl(''),
    "Correo":new FormControl(''),
    "BancoSoles":new FormControl(''),
    "BancoDolar":new FormControl(''),
    "Alta_Usuario":new FormControl(this.user.Usuario,  Validators.required),
    });
  }

  ngOnInit() {
    this.ListarRepresentantesEmpresa(this.idEmpresa);
    this.ListarReferenciasBancarias(this.idEmpresa);
  }

  tipoServicioSelect(event) {
    const ctrl = this.formularioGenerarContrato.get('Pagare');
    if (event == this.Id_Descuento) {
      this.formularioGenerarContrato.controls["Pagare"].setValue(true);
      ctrl.disable();
    }else{
      ctrl.enable();
    }
    this.formularioGenerarContrato.controls['Tipo_Servicio'].setValue(event);
  }

  representanteIF(event){
    this.selectedItems = event;
  }
  representanteCLI(event){
    this.selectedItemsCLI = event;
  }

  calcularFechaFin(){
    let now = moment(this.formularioGenerarContrato.controls["Fecha_Inicio"].value._d).add(2,'years').subtract(1,'days');
    this.formularioGenerarContrato.controls["Fecha_Final"].setValue(now);
  }

  ListarRepresentantesEmpresa(idEmpresa){
    this.guiasService.setDataRepresentanteCLI([]);
    this.loading = true;
    this.empresasService.obtenerContactosEmpresa(idEmpresa).subscribe(
      res => {       
          this.rProvCombo = res;
            let tipoContacto: any = [];
            let guiaTipo: any;
            this.guiasService.TipoContacto.subscribe(
              response => {
                tipoContacto = response;
                guiaTipo = tipoContacto.find(state => state.Codigo.toLowerCase().indexOf('rl') === 0)
              }
            );          
            this.rProvCombo = this.rProvCombo.filter(
              state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 && state.Tipo_de_Contacto === guiaTipo.idGuia
            );        
            this.guiasService.setDataRepresentanteCLI(this.rProvCombo);
          this.loading = false;
      },(err: HttpErrorResponse)=> {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
            this.msgStatus.getMessage(err.status);            
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA REPRESENTANTES NO OBTENIDO. "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      }) ;
  }

  ListarReferenciasBancarias(idProvi){
    this.loading = true;
    this.empresasService.obtenerReferenciasBancariasEmpresa(idProvi).subscribe(
      res => {       
          this.rProvRefBancarias = res;
          this.rProvRefBancariasDolares = this.rProvRefBancarias.filter(
            state => state.Moneda == this.Label_id_dolares && state.Estado.toLowerCase().indexOf('activo') === 0 && state.FlgPredeterminado == 1 && state.Tipo_Servicio == this.tipoServicio
          );
          this.rProvRefBancarias = this.rProvRefBancarias.filter(
            state => state.Moneda == this.Label_id_soles && state.Estado.toLowerCase().indexOf('activo') === 0 && state.FlgPredeterminado == 1 && state.Tipo_Servicio == this.tipoServicio
          );
          this.loading = false;
      },err =>{
          Swal.fire({
            title: "¡Algo salió mal!",
            footer:  err.error['error'],
            type: "warning",
            allowOutsideClick: true,
            heightAuto: false
          });        
        this.loading = false;
      }
    )
  }
  
  crearContratoMarco(){
   
    this.formatearFormSend();
    this.addDataSelects();
    if (this.formularioGenerarContrato.controls['Pagare'].value == false) {
      this.Pagare = 'N'
    }else{
      this.Pagare = 'S'
    }

    this.dataEnviar.idEmpresa =  this.formularioGenerarContrato.controls['idEmpresa'].value
    this.dataEnviar.Tipo_Servicio =  this.formularioGenerarContrato.controls['Tipo_Servicio'].value
    this.dataEnviar.Tipo_Proceso =  this.Id_Contrato_Marco;
    this.dataEnviar.Fecha_Inicio =  this.formularioGenerarContrato.controls['Fecha_Inicio'].value
    this.dataEnviar.Fecha_Final =  this.formularioGenerarContrato.controls['Fecha_Final'].value
    this.dataEnviar.Pagare =  this.Pagare;
    this.dataEnviar.IF_Representante_Legal_1 =  " "
    this.dataEnviar.PRV_Representante_Legal_1 =  " "
    this.dataEnviar.IF_Representante_Legal_2 =  " "
    this.dataEnviar.PRV_Representante_Legal_2 =  " "
    this.dataEnviar.Correo =  " "
    this.dataEnviar.BancoSoles =  this.formularioGenerarContrato.controls['BancoSoles'].value
    this.dataEnviar.BancoDolar =  this.formularioGenerarContrato.controls['BancoDolar'].value
    this.dataEnviar.Alta_Usuario =  this.formularioGenerarContrato.controls['Alta_Usuario'].value

    /*if (this.dataEnviar.BancoSoles == "" && this.dataEnviar.BancoDolar == "") {
      Swal.fire({
        title: "¡Advertencia!",
        text: "Seleccione banco",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });   
      return
    }*/
    this.loading = true;
    this.empresasService.guardarContratoMarco(this.dataEnviar)
    .subscribe(res => {
      this.loading = false;
      this.save = true;
      Swal.fire({
        title: 'Registrado con éxito',
        text: '¿Desea enviar contrato digital a WhatSign.?',
        type: "success",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        heightAuto: false
      }).then((result) => {
        if (result.value) {
          this.dataContract = res;
          this.dataEnviarKeynua.IDCMarco = this.dataContract.IDCMarco
          this.enviarContratoMarcoElectronico(this.dataEnviarKeynua);
        }else if (
          result.dismiss === Swal.DismissReason.cancel
        ) {
          this.loading = false;
        }
      });

    },(err: HttpErrorResponse)=> {
      this.loading = false;
      if (err.error instanceof ErrorEvent) {
        console.error("Error Event");
      } else {
          this.msgStatus.getMessage(err.status);            
      }
      Swal.fire({
        title: this.msgTitulos.Error,
        text: "Contrato marco no creado. "+this.msgStatus.message ,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      })
    })      
  } 
  
  enviarContratoMarcoElectronico(dataEnviarKeynua){
    
   this.firmaElectronicaService.enviarContratoMarcoElectronico(dataEnviarKeynua).subscribe(
       res => {       
         this.showNotification('success','top','right','Documento enviado satisfactoriamente para su firma digital.');
       },err => {
        if (err.error.message) {
         this.showNotification('warning','top','right','No se pudo enviar contrato digital a WhatSign. \n Error: ' + err.error.message);
        }else{
         let error = "";
         error = err.error.error;
         this.showNotification('warning','top','right','No se pudo enviar contrato digital a WhatSign. \n Error: ' + error);
        }
      
      }
   );
 }

  formatearFormSend(){
    let fec_ini = this.datePipe.transform(this.formularioGenerarContrato.controls["Fecha_Inicio"].value,"yyyy-MM-dd");
    let fec_fin = this.datePipe.transform(this.formularioGenerarContrato.controls["Fecha_Final"].value,"yyyy-MM-dd");
    
    this.formularioGenerarContrato.controls["Fecha_Inicio"].setValue(fec_ini);
    this.formularioGenerarContrato.controls["Fecha_Final"].setValue(fec_fin);
  }

  addDataSelects(){
    this.dataEnviar.Firmantes = [];
    this.dataEnviar.FirmantesIF = [];
    this.dataEnviar.FirmantesAd = [];
    this.selectedItemsCLI.forEach(item => { 
      this.dataEnviar.Firmantes.push(
        {
          'Nombre_Firmante' : item.Nombre_de_Contacto,
          'Correo' : item.Correo,
          'Telefono': item.NroMovil_Laboral,
          'Tipo_Doc_Identificacion':item.Tipo_Documento_Identidad,
          'Tipo_Doc_Identificacion_Dsc':item.Tipo_Documento_Identidad_Dsc,
          'Num_Doc_Identificacion': item.Nro_Documento_Identidad,
          'Tipo_Firmante': item.Rol_del_Contacto,
          'Cargo' : item.Rol_Del_Contacto_Dsc,
          'Raz_Social' : item.Razon_Social,
          'RUC' : item.Num_Doc_Identificacion,
          'Direccion': item.Direccion_Persona,
          'Distrito':item.Distrito,
          'Provincia':item.Provincia,
          'Departamento':item.Departamento
         }
      );
      this.dataEnviar.FirmantesAd.push(
        {
          'Nombre_Firmante' : item.Nombre_de_Contacto,
          'Correo' : item.Correo,
          'Telefono': item.NroMovil_Laboral,
          'Tipo_Doc_Identificacion':item.Tipo_Documento_Identidad,
          'Tipo_Doc_Identificacion_Dsc':item.Tipo_Documento_Identidad_Dsc,
          'Num_Doc_Identificacion': item.Nro_Documento_Identidad,
          'Tipo_Firmante': item.Rol_del_Contacto,
          'Cargo' : item.Rol_Del_Contacto_Dsc,
          'Raz_Social' : item.Razon_Social,
          'RUC' : item.Num_Doc_Identificacion,
          'Direccion': item.Direccion_Persona,
          'Distrito':item.Distrito,
          'Provincia':item.Provincia,
          'Departamento':item.Departamento
         }
      )
    });
    this.selectedItems.forEach(item => { 
      this.dataEnviar.Firmantes.push(item)
      this.dataEnviar.FirmantesIF.push(item)
    });
  }

  SetearCorreo(idContacto){
    if(this.rProvCombo.length > 0){
      
      this.rProvArray = this.rProvCombo.filter(
        state => state.idContacto == idContacto
      );

      this.formularioGenerarContrato.controls['Correo'].setValue(this.rProvArray[0].Correo);
      this.formularioGenerarContrato.controls['PRV_Representante_Legal_1'].setValue(this.rProvArray[0].idContacto);
    }
  }

  SetearRefBancariaSoles(idCuenta){
    if(this.rProvRefBancarias.length > 0){
      this.rRefBancariaArray = this.rProvRefBancarias.filter(
        state => state.idCuenta == idCuenta
      );
      let descripcionBanco = 
        ((this.rRefBancariaArray[0].Tipo_de_Cuenta == 90) ? "A":"C")+"|"+
        this.rRefBancariaArray[0].NroCuenta+"|"+
        this.rRefBancariaArray[0].Banco_Dsc+"|"+
        ((this.rRefBancariaArray[0].Moneda == this.Label_id_dolares) ? "D":"S")+"|"+
        this.rRefBancariaArray[0].CCI+"|"+
        this.rRefBancariaArray[0].idCuenta;
      this.formularioGenerarContrato.controls['BancoSoles'].setValue(descripcionBanco);
    }
  }

  SetearRefBancariaDolares(idCuenta){
    if(this.rProvRefBancariasDolares.length > 0){
      this.rRefBancariaArray = this.rProvRefBancariasDolares.filter(
        state => state.idCuenta == idCuenta
      );
      let descripcionBanco = 
      ((this.rRefBancariaArray[0].Tipo_de_Cuenta == 90) ? "A":"C")+"|"+
        this.rRefBancariaArray[0].NroCuenta+"|"+
        this.rRefBancariaArray[0].Banco_Dsc+"|"+
        ((this.rRefBancariaArray[0].Moneda == this.Label_id_dolares) ? "D":"S")+"|"+
        this.rRefBancariaArray[0].CCI+"|"+
        this.rRefBancariaArray[0].idCuenta;
      this.formularioGenerarContrato.controls['BancoDolar'].setValue(descripcionBanco);
    }
  }

  nuevoContacto(){
    this.idContactoS = "";
    this.empresasService.addContactoEmpresa = true;
    this.abrirAgregarContacto = true;
  }

  SetearRepIF(idRepresentanteIF){
    this.formularioGenerarContrato.controls['IF_Representante_Legal_1'].setValue(idRepresentanteIF);
  }
  
  CerrarPopUp(){ 
    this.cerrarContratoMarcoNuevo.emit();
    this.guiasService.setDataRepresentanteCLI([]);
  }
  CerrarPopUpContacto(click:boolean){
    this.abrirAgregarContacto = false; 
  }

  Refresh() {
    this.ngOnInit();
  }

  showNotification(type,from,align,message){
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
    }

}
